// LucideDashboardIcons.js
// Centralized Lucide icon mapping for dashboard metrics, actions, and activity
import {
  FileText,
  DollarSign,
  ShoppingCart,
  BarChart2,
  ClipboardList,
  Package,
  Truck,
  Undo2,
  Users,
  CreditCard,
  ArrowRight,
  Clock3,
  MapPin,
  Receipt,
} from 'lucide-react';

export const LucideDashboardIcons = {
  // Metrics
  Revenue: DollarSign,
  'Total Sales': ShoppingCart,
  'Outstanding Invoices': FileText,
  Receipts: Receipt,
  'New Customers': Users,
  'Bills Due': CreditCard,
  'Stock On Hand': Package,
  'Reports Viewed': BarChart2,
  'Open Orders': ClipboardList,
  'Ready to Pick': Package,
  Backorders: Truck,
  'Stale Opening Hours': Clock3,
  'Stale Address': MapPin,
  // Activity Types
  invoice: FileText,
  payment: DollarSign,
  order: Package,
  shipment: Truck,
  return: Undo2,
  // Fallback
  default: ClipboardList,
  // Deadlines
  deadline: ArrowRight,
};
